"use client";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { motion } from "framer-motion";
import AnimatedButton from "../ui/AnimatedButton";
import AnimatedText from "../ui/AnimatedText";
import image from "../../../public/assets/newHomeImage/Union.png";
import heroImage from "@/assets/image/m1New11.png";
import heroImage1 from "@/assets/image/m2.svg";
import heroImage2 from "@/assets/image/m3.svg";
import heroImage3 from "@/assets/image/m4.svg";
import heroImage4 from "@/assets/image/m5.svg";
import { IconArrowRight } from "@tabler/icons-react";
import Marketing from "./Marketing";
import CryptoPlateform from "./CryptoPlateform";
import CoinUpdate from "./CoinUpdate";

const Hero = () => {
  const router = useRouter();

  return (
    <section
      className="w-full bg-cover bg-center relative overflow-hidden"
      style={{ backgroundImage: `url(${image.src})` }}
    >
      <div className="flex items-center justify-center w-full mt-4 md:mt-0">
        <div className="container-wrapper mx-auto px-4 sm:px-6 md:px-8 lg:px-16 py-0 flex flex-col md:flex-row items-center gap-8 md:gap-6">
          {/* Left Content */}
          <div className="flex-1 w-full flex flex-col gap-4 sm:gap-6 items-center md:items-start text-center md:text-left">
            {/* Button */}
            {/* <div className="flex justify-center md:justify-start">
              <AnimatedButton
                onClick={() => router.push("/spot-trade")}
                className="py-1 px-4 sm:px-5 flex flex-row gap-2 bg-lightGreen border border-borderGreen text-textGreen rounded-full !font-medium text-[11px] sm:text-[12px] leading-6 tracking-[0.15px]"
              >
                Featured Coins
              </AnimatedButton>
            </div> */}

            {/* Heading */}
            <h1 className="text-primaryText !font-outfit text-[28px] xs:text-[32px] sm:text-[40px] md:text-[48px] lg:text-[57px] leading-tight tracking-tight md:text-start text-center max-w-[90%] sm:max-w-full">
              {/* <AnimatedText text="Empowering Your V.D.A Journey with Paraacrypto" /> */}
              Empowering Your V.D.A Journey with Paraacrypto
            </h1>

            {/* Description */}
            <AnimatedText
              text="With the credibility of an FIU license, our platform combines security and simplicity to meet the needs of both beginners and professional traders in India."
              className="font-outfit text-smallText text-[13px] xs:text-[14px] sm:text-[15px] md:text-lg leading-5 tracking-[0.25px] md:leading-6 md:tracking-[0.15px] md:text-start text-center max-w-[85%] sm:max-w-[85%] font-normal"
              delay={0.5}
            />

            {/* Button for Trading */}
            <div className="flex justify-center md:justify-start mt-2 sm:mt-0">
              <AnimatedButton
                onClick={() => router.push("/spot-trade")}
                className="py-2 px-4 sm:px-5 flex flex-row gap-2 h-[42px] min-w-[146px] bg-activeBtnO text-white rounded-xl weight500 text-[14px] sm:text-[16px] leading-6 tracking-[0.15px] shadow-[0px_2px_0px_0px_#FFFFFF56_inset,0px_2px_2px_0px_#6E828A26]"
              >
                Start Trading
                <IconArrowRight className="w-5 h-5 sm:w-6 sm:h-6" />
              </AnimatedButton>
            </div>
          </div>

          {/* Right Image Section */}
          <div className="flex-1 w-full relative h-[280px] xs:h-[350px] sm:h-[450px] md:h-[550px] lg:h-[650px] xl:h-[700px]">
            <motion.div
              className="hidden top-[5%] -right-[5%] w-16 xs:w-20 sm:w-24 md:w-28 lg:w-32 aspect-square rounded-full z-0"
              style={{
                background:
                  "linear-gradient(180deg, #09F0A0 0%, #E3EFFF 75.48%)",
                filter: "blur(6px)",
                opacity: 0.3,
              }}
              animate={{ rotate: 360 }}
              transition={{
                duration: 20,
                repeat: Infinity,
                ease: "linear",
                repeatType: "loop",
              }}
            />

            <motion.img
              className="absolute bottom-[10%] xs:bottom-[15%] sm:bottom-[20%] -left-[5%] xs:-left-[3%] sm:-left-[2%] w-20 xs:w-24 sm:w-28 md:w-32 lg:w-36 aspect-square rounded-full z-0"
              style={{
                // backgroundImage: `url(${round})`,
                // backgroundSize: "cover",
                // background: "linear-gradient(180deg, #09F0A0 0%, #E3EFFF 75.48%)",
                // filter: "blur(6px)",
                opacity: 0.9,
              }}
              animate={{ rotate: -360 }}
              transition={{
                duration: 5,
                repeat: Infinity,
                ease: "linear",
                repeatType: "loop",
              }}
              // src={`${round}`}
              src="/assets/images/m11.svg"
              alt="dashboard"
              // src="https://paraacrypto.com/_next/static/media/favicon.007bd29c.svg"
            />
            {/* <Image 
onContextMenu={(e) => e.preventDefault()}
                src={round}
                alt="Trading Dashboard"
                fill
                priority
                sizes="(max-width: 768px) 100vw, 50vw"
                // className="object-contain rounded-2xl hidden md:block"
              style={{
                // backgroundImage: `url(${round})`,
                // backgroundSize: "cover",
                // background: "linear-gradient(180deg, #09F0A0 0%, #E3EFFF 75.48%)",
                filter: "blur(6px)",
                opacity: 0.9
              }}
              /> */}

            {/* </motion.img> */}
            <motion.div
              className="absolute top-[30%] xs:top-[33%] sm:top-1/3 -right-[8%] xs:-right-[6%] sm:-right-[4%] md:-right-[2%] w-28 xs:w-32 sm:w-36 md:w-40 lg:w-44 aspect-square rounded-full z-0"
              style={{
                background:
                  "linear-gradient(180deg, #09F0A0 0%, #E3EFFF 75.48%)",
                filter: "blur(6px)",
                opacity: 0.15,
              }}
              animate={{ rotate: 360 }}
              transition={{
                duration: 30,
                repeat: Infinity,
                ease: "linear",
                repeatType: "loop",
              }}
            />

            {/* Main Dashboard Image */}
            <motion.div
              className="relative w-full h-full"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
            >
              <Image
                onContextMenu={(e) => e.preventDefault()}
                src={heroImage}
                alt="Trading Dashboard"
                fill
                priority
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 70vw"
                className="object-contain rounded-2xl hidden md:block scale-125"
              />
            </motion.div>
            <motion.div
              className="relative w-full h-full"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
            >
              <Image
                onContextMenu={(e) => e.preventDefault()}
                src={heroImage}
                alt="Trading Dashboard"
                // fill
                priority
                sizes="(max-width: 768px) 100vw, 50vw"
                className="object-contain rounded-2xl block md:hidden scale-125"
              />
            </motion.div>

            {/* Top Left Coin Card */}
            <motion.div
              className="absolute !top-[25%] xs:!top-[28%] sm:!top-[30%] left-[2%] sm:left-[3%] w-[50px] xs:w-[60px] sm:w-[70px] md:w-[90px] lg:w-[110px] -z-10"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, delay: 0.2, ease: "easeOut" }}
              whileHover={{ scale: 1.05 }}
            >
              <Image
                onContextMenu={(e) => e.preventDefault()}
                src={heroImage1}
                alt="Coin Card"
                className="w-full h-auto object-contain drop-shadow-xl"
              />
            </motion.div>

            {/* Bottom Right Trading Card */}
            <motion.div
              className="absolute bottom-[12%] xs:bottom-[15%] md:bottom-[20%] right-[3%] xs:right-[5%] w-[50px] xs:w-[60px] sm:w-[80px] md:w-[90px] lg:w-[120px] z-10"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, delay: 0.4, ease: "easeOut" }}
              whileHover={{ scale: 1.05 }}
            >
              <Image
                onContextMenu={(e) => e.preventDefault()}
                src={heroImage2}
                alt="Trading Card"
                className="w-full h-auto object-contain drop-shadow-xl"
              />
            </motion.div>
            <motion.div
              className="absolute top-[15%] xs:top-[22%] md:top-[28%] right-[3%] xs:right-[5%] w-[50px] xs:w-[60px] sm:w-[80px] md:w-[90px] lg:w-[120px] z-10"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, delay: 0.4, ease: "easeOut" }}
              whileHover={{ scale: 1.05 }}
            >
              <Image
                onContextMenu={(e) => e.preventDefault()}
                src={heroImage4}
                alt="Trading Card"
                className="w-full h-auto object-contain drop-shadow-xl"
              />
            </motion.div>

            {/* Bottom Left Stats Card */}
            <motion.div
              className="absolute bottom-[18%] xs:bottom-[20%] md:bottom-[25%] left-[3%] xs:left-[5%] w-[80px] xs:w-[100px] sm:w-[140px] md:w-[160px] lg:w-[180px] z-10"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.6, ease: "easeOut" }}
              whileHover={{ scale: 1.05 }}
            >
              <Image
                onContextMenu={(e) => e.preventDefault()}
                src={heroImage3}
                alt="Stats Card"
                className="w-full h-auto object-contain drop-shadow-xl"
              />
            </motion.div>
          </div>
        </div>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, type: "spring", bounce: 0.3 }}
      >
        <Marketing />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, type: "spring", bounce: 0.3 }}
      >
        <CryptoPlateform />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, type: "spring", bounce: 0.3 }}
      >
        <CoinUpdate />
      </motion.div>
    </section>
  );
};

export default Hero;
